import React, { useEffect, useMemo, useState } from "react";
import api from "api";

export default function AdminPricingsSelect({
  value,
  onChange,
  placeholder = "Sélectionner un tarif…",
  showTotal = true
}) {
  const [pricings, setPricings] = useState([]);
  const [loading, setLoading] = useState(true);

  // ----------------------------------------------------
  // Load pricings
  // ----------------------------------------------------
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await api.get("/admin/formalities/pricings");
        setPricings(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error("LOAD PRICINGS ERROR", e);
        setPricings([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // ----------------------------------------------------
  // Active + tri alpha
  // ----------------------------------------------------
  const activePricings = useMemo(() => {
    return pricings
      .filter(p => p.fpStatus === "active")
      .sort((a, b) => a.fpLabel.localeCompare(b.fpLabel));
  }, [pricings]);

  const isEmpty = !loading && activePricings.length === 0;

  const formatPrice = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return "";
    return num.toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " €";
  };

  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------
  return (
    <select
      className="form-select"
      disabled={loading || isEmpty}
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
    >
      {loading && <option>Chargement…</option>}

      {isEmpty && <option>Aucun tarif actif</option>}

      {!loading && !isEmpty && (
        <>
          <option value="">{placeholder}</option>

          {activePricings.map((pricing) => (
            <option key={pricing.fpCode} value={pricing.fpCode}>
              {pricing.fpLabel}
              {showTotal && pricing.fpTotalPriceIT
                ? ` – ${formatPrice(pricing.fpTotalPriceIT)} TTC`
                : ""}
            </option>
          ))}
        </>
      )}
    </select>
  );
}